export default __webpack_public_path__ + "static/media/empty.c0025e58.svg";